<template>
  <div id="write-a-review">
    <!-- <a -->
    <!--   href="https://blog.hellopeter.com/giveaway/write-a-review-for-your-favourite-romantic-restaurant-in-mzansi-and-win" -->
    <!--   target="_blank"><img alt="Valentine's campaign" class="valentines-banner is-hidden-mobile" -->
    <!--                        src="/static/img/valentines/v-write-desktop.png" -->
    <!--                        srcset="/static/img/valentines/v-write-desktop.png 1x, /static/img/valentines/v-write-desktop@2x.png 1.5x, /static/img/valentines/v-write-desktop@2x.png 2x, /static/img/valentines/v-write-desktop@3x.png 3x"/></a> -->
    <!-- <img alt="Valentine's campaign" class="valentines-banner is-hidden-tablet" -->
    <!--      src="/static/img/valentines/v-other-mobile.png" -->
    <!--      srcset="/static/img/valentines/v-other-mobile.png 1x, /static/img/valentines/v-other-mobile@2x.png 1.5x, /static/img/valentines/v-other-mobile@2x.png 2x, /static/img/valentines/v-other-mobile@3x.png 3x"/> -->
    <div id="twentykCampBanner">
      <a target="_blank" href="https://blog.hellopeter.com/giveaway/win-r20000-by-reviewing-a-business-not-on-hellopeter?utm_source=write+a+review+banner+&utm_medium=banner&utm_campaign=20K+Write+A+review+&utm_term=write+a+review+banner+">
        <img :src="`${twentykCampImgPath}.webp?1`"
             :srcset="`${twentykCampImgPath}@2x.webp?1 1.5x,
                 ${twentykCampImgPath}@2x.webp?1 2x,
                 ${twentykCampImgPath}@3x.webp?1 3x`"/>
      </a>
    </div>
    <section class="write-review" @click="closeOrgLookup">
      <div v-if="is_fetching_initial_data">

      </div>
      <div v-if="!is_fetching_initial_data">
        <flash-message :addBottomMargin="true" :class="{'isErrorVisible': isErrorVisible}"></flash-message>
        <h1 v-if="isBusinessFromSlug" class="has-text-weight-bold font-roboto" v-html="shareYourExperienceMarkup"
            @click.prevent="closeOrgLookup"></h1>
        <h1 v-if="!isBusinessFromSlug" class="has-text-weight-bold font-roboto" @click.prevent="closeOrgLookup">Share your
          experience:</h1>
        <div v-if="!isBusinessFromSlug" class="field">
          <label class="label">Which business would you like to review?</label>
          <review-business-search @businessSelected="selectOrg" @input="clearBusiness"></review-business-search>
          <p v-if="form.errors.has('business_name')" class="help is-danger"
             v-html="form.errors.get('business_name')"></p>
        </div>
        <div v-if="!isMatchedToExistingBusiness" class="field">
          <label :class="['label', {'disabled':disableDropDown}]" :disabled="disableDropDown"
                 @click.prevent="closeOrgLookup">Please select an industry:</label>
          <div :class="['control', {'disabled':disableDropDown}]" :disabled="disableDropDown">
            <div :class="{'is-active' : show_dropdown}" class="dropdown hp-dropdown" @mouseleave="hideDropdown()">
              <div class="dropdown-trigger">
                <button :disabled="disableDropDown" aria-controls="dropdown-menu3" aria-haspopup="true"
                        class="button-dropdown" @focus="closeOrgLookup()" @click.prevent="showDropdown()">
                  <span ref="industry_name" :class="['is-size-6', {'disabled':disableDropDown}]"
                        v-html="selectedIndustry">Industry</span>
                  <span :class="['icon', 'is-small', {'disabled':disableDropDown}]"><i aria-hidden="true"
                                                                                       class="fas fa-angle-down"></i></span>
                </button>
              </div>
              <div class="dropdown-menu" role="menu">
                <div class="dropdown-content is-paddingless">
                  <a v-for="industry in industries" :ref="`${industry.id}`"
                     class="dropdown-item"
                     href="#"
                     @focus="closeOrgLookup()"
                     v-html="industry.name"
                     @click.prevent="selectIndustry(industry)">
                  </a>
                </div>
              </div>
            </div>
          </div>
          <p v-if="form.errors.has('industry')" class="help is-danger" v-html="form.errors.get('industry')"></p>
        </div>
        <!-- RATING -->
        <div class="field">
          <label :class="['label', {'disabled':disableRating}]">Rating:</label>
          <div :class="['control', {'disabled':disableRating}]">
            <rating v-model="form.rating" :disabled="disableRating" :rating="form.rating" :spacer="ratingSpacer"
                    tabindex="2" @focus="closeOrgLookup"></rating>
          </div>
          <p v-if="form.errors.has('rating')" class="help is-danger" v-html="form.errors.get('rating')"></p>
        </div>
        <!-- REVIEW CONTENT -->
        <div class="field">
          <label :class="['label', {'disabled':disableReviewContent}]">Your review</label>
          <div :class="['control', {'disabled':disableReviewContent}]">
            <textarea v-model="form.content" :disabled="disableReviewContent" class="textarea has-fixed-size hp-textarea"
                      placeholder="Share your experience and help others make informed decisions"
                      tabindex="3"
                      @focus="closeOrgLookup"></textarea>
          </div>
          <p v-if="form.errors.has('content')" class="help is-danger" v-html="form.errors.get('content')"></p>
        </div>
        <!-- REVIEW TITLE -->
        <div class="field" @focus="closeOrgLookup">
          <label :class="['label', {'disabled':disableReviewTitle}]">Review title:</label>
          <div :class="['control', {'disabled':disableReviewTitle}]" @focus="closeOrgLookup">
            <input v-model="form.review_title" :disabled="disableReviewTitle" class="input hp-input" placeholder=""
                   tabindex="4" type="text" @focus="closeOrgLookup">
          </div>
          <p v-if="form.errors.has('review_title')" class="help is-danger" v-html="form.errors.get('review_title')"></p>
        </div>

        <div v-if="canUploadPhotos" class="field font-size-14">
          <div v-if="form.uploadedPhotos.length < 5" class="photo-row is-clearfix">
            <img class="photo-row-img" src="/static/img/others/camera.svg"/>
            <input ref="filePicker" accept="image/png, image/jpeg" class="is-hidden" type="file" @change="pickPhoto">
            <a class="link--v2" href="#" @click.prevent="openPhotoPicker">Add a photo</a>
            <span class="font-size-12 is-pulled-right">{{ form.uploadedPhotos.length }}/5 photos added</span>
          </div>

          <template v-if="form.uploadedPhotos.length">
            <div v-for="(photo, index) in form.uploadedPhotos" class="photo-row is-clearfix margin-top-10">
              <template v-if="'content' in photo">
                <img :src="photo.content" class="photo-row-img photo-row-thumbnail is-pulled-left"/>
                <a class="is-pulled-right photo-row-remove" href="#" @click.prevent="removePhoto(index)">
                  <img class="" src="/static/img/others/clear.svg"/>
                </a>
                <span class="is-clipped is-block padding-top-6 padding-bottom-1">{{ photo.name }}</span>
              </template>
              <template v-else>
                <img class="photo-row-img photo-row-thumbnail is-pulled-left"
                     src="/static/img/others/thumbnail.svg"/>
                <img class="is-pulled-left photo-row-error-img" src="/static/others/error.svg"/>
                <a class="is-pulled-right photo-row-remove" href="#" @click.prevent="removePhoto(index)">
                  <img class="" src="/static/img/others/clear.svg"/>
                </a>
                <span class="help is-clipped is-danger font-size-11">
                  The image selected is either in the incorrect file format or has exceeded the size limit. Please try again.
                </span>
              </template>
            </div>
          </template>
        </div>

        <div v-if="showNewBusinessEmail || showUnclaimedBizEmail" class="field" @click.prevent="closeOrgLookup">
          <label v-if="!showUnclaimedBizEmail" :class="['label', {'disabled':disableReviewEmail}]">This business isn't
            yet registered on Hellopeter. Enter their email address below, and we'll let them know about your
            review.</label>
          <label v-if="showUnclaimedBizEmail" :class="['label', {'disabled':disableReviewEmail}]">This business isn't
            claimed on Hellopeter. Enter their email address below, and we'll let them know about your review.</label>
          <div :class="['control', {'disabled':disableReviewEmail}]">
            <input v-model="form.new_business_email" :disabled="disableReviewEmail" class="input hp-input"
                   placeholder="Enter business email address"
                   tabindex="5" type="text">
          </div>
          <p v-if="form.errors.has('new_business_email')" class="help is-danger"
             v-html="form.errors.get('new_business_email')"></p>
        </div>
        <!-- ADDITIONAL INFO -->
        <div v-if="showAdditionalInformation" @click.prevent="closeOrgLookup">
          <div class="field">
            <h4 class="title has-text-weight-bold">Additional information</h4>
            <label class="label">Help this business learn from your experience by providing as much information as
              possible. This information will not be displayed on your public review, and is only visible to the
              business.</label>
          </div>
          <div class="field">
            <label class="label">Reference number:</label>
            <div class="control">
              <input v-model="form.reference_number" class="input hp-input" placeholder="" tabindex="6" type="text">
            </div>
          </div>
          <div class="field">
            <label class="label">ID number:</label>
            <div class="control">
              <input v-model="form.id_number" class="input hp-input" placeholder="" tabindex="7" type="text">
            </div>
          </div>
          <div class="field">
            <label class="label">Cellphone number:<span class="required">*</span></label>
            <div class="control">
              <input v-model="form.cell_number" class="input hp-input" placeholder="" tabindex="8" type="tel">
            </div>
            <p v-if="isInvalidCellNumber" class="help is-danger">Please input a 10 digit cellphone number</p>
          </div>
          <div class="field">
            <label class="label">Branch:</label>
            <div class="control">
              <input v-model="form.branch" class="input hp-input" placeholder="" tabindex="9" type="text">
            </div>
          </div>
        </div>
        <label v-if="$router.currentRoute.query.t !== undefined && !isLoggedIn && is_new_user"
               class="label invite-message">By publishing a review
          you agree to Hellopeter creating an account and to Hellopeter's <a href="/legal/legal" target="_blank" class="link--v2 link--no-line">general
            terms</a> and <a href="/legal/privacy" class="link--v2 link--no-line" target="_blank">privacy policy</a></label>
        <!-- <p class="is-center"></p> -->
        <div class="has-text-centered">
          <button :class="['is-hidden-mobile button hp-btn-primary', { 'is-loading': is_loading }]"
                  :disabled="disablePublishButton"
                  tabindex="10"
                  v-on:click="publishReview">PUBLISH REVIEW
          </button>
          <div class="clear is-hidden-mobile"></div>
          <button
            :class="['is-hidden-tablet bottom-margin is-fullwidth button hp-btn-primary', { 'is-loading': is_loading }]"
            :disabled="disablePublishButton"
            tabindex="11"
            v-on:click="publishReview">PUBLISH REVIEW
          </button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
import axios from 'axios'
import ApiResource from '@/api/ApiResource'
import RatingNew from '@/components/RatingNew'
import misc from '@/mixins/misc.js'
import auth from '@/mixins/auth.js'
import FlashMessage from '@/components/FlashMessage'
import ReviewBusinessSearch from '@/components/ReviewBusinessSearch'

export default {
  name: 'WriteReview',
  mixins: [misc, auth],
  props: {
    slug: {
      type: String,
      default: ''
    }
  },
  components: {
    // Rating,
    'Rating': RatingNew,
    FlashMessage,
    ReviewBusinessSearch
  },
  metaInfo () {
    return {
      title: this.metaTitle
    }
  },
  data () {
    return {
      isErrorVisible: false,
      is_fetching_initial_data: false,
      is_loading: false,
      ratingSpacer: true,
      fullWidthDropDown: true,
      show_dropdown: false,
      industries: [],
      selectedIndustry: 'Select industry',
      businessPropertyDetail: {
        id: 0,
        industry_id: 0,
        industry_name: '',
        name: ''
      },
      form: new ApiResource({
        business: '',
        business_id: '',
        business_name: '',
        business_slug: '',
        industry: '',
        rating: 0,
        content: '',
        review_title: '',
        new_business_email: '',
        reference_number: '',
        id_number: '',
        cell_number: ((localStorage.getItem('mobile') !== 'null' && localStorage.getItem('mobile')) ? localStorage.getItem('mobile') : ''),
        branch: '',
        status: '',
        subscription: '',
        source: '',
        full_url: '',
        token: (this.$router.currentRoute.query.t === undefined) ? null : this.$router.currentRoute.query.t,
        uploadedPhotos: [],
        sendWebhook: ''
      }),
      businesses: [],
      org_selected: false,
      business_available: undefined,
      drop_down_opened: false,
      on_blur_close: false,
      showUnclaimedBizEmail: false,
      is_new_user: false,
      add_photo: 'no'
    }
  },
  created () {
    //check if review already written for a single invite link
    if (this.$router.currentRoute.query.t !== undefined && !this.isLoggedIn) {
      this.isReviewerAlreadyWrittenReviewForInvite()
    } else if (!this.isLoggedIn) {
      let query = JSON.parse(JSON.stringify(this.$route.query))
      this.$router.push({path: '/login', query})
    }
    this.getIndustries()
    this.getReviewTemplatesetting()
    if (this.$route.query.rate && (typeof this.$route.query.rate !== 'undefined')) {
      this.form.rating = this.$route.query.rate
    }
    if (this.$route.query.reviewTitle && (typeof this.$route.query.reviewTitle !== 'undefined')) {
      this.form.review_title = this.$route.query.reviewTitle
    }
    if (this.$route.query.reviewContent && (typeof this.$route.query.reviewContent !== 'undefined')) {
      this.form.content = this.$route.query.reviewContent
    }
    if (this.$route.query.source && (typeof this.$route.query.source !== 'undefined')) {
      this.form.source = this.$route.query.source
      this.form.full_url = this.$route.fullPath
    }
    if (typeof this.$route.query.completionRedirect !== 'undefined' && this.$route.query.completionRedirect.length > 0) {
      this.form.sendWebhook = this.$route.query.completionRedirect
    }
    if (this.slug.length > 0) {
      /**
       * if all the review data is present in query string, we directly post review to API
       */
      if (
        (this.$route.query.rate && typeof this.$route.query.rate !== 'undefined') &&
        (this.$route.query.reviewTitle && typeof this.$route.query.reviewTitle !== 'undefined') &&
        (this.$route.query.reviewContent && typeof this.$route.query.reviewContent !== 'undefined') &&
        (this.$route.query.source && typeof this.$route.query.source !== 'undefined') &&
        (this.$route.query.t && typeof this.$route.query.t !== 'undefined')
      ) {
        this.getBasicBusinessDetail().then(() => {
          this.publishReview()
        })
      } else {
        this.getBasicBusinessDetail()
      }
    } else {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: this.metaTitle,
        brandName: '',
        industryName: ''
      })
      window.prerenderReady = true
    }

    window.events.$on('business-search', this.selectOrg)
  },
  destroyed () {
    window.events.$off('business-search')
  },
  methods: {
    /**
     * Open file picker to select photos
     */
    openPhotoPicker () {
      this.$refs.filePicker.value = ''
      this.$refs.filePicker.click()
    },

    /**
     * Pick the user selected photo
     *
     * @param {Object} e Event handler object
     */
    pickPhoto (e) {
      const image = e.target.files[0]
      if (['image/png', 'image/jpeg'].includes(image.type) && image.size >= 10000 && image.size <= 5000000) {
        const reader = new FileReader()
        reader.onload = () => {
          image.content = reader.result
          this.form.uploadedPhotos.push(image)
        }
        reader.readAsDataURL(image)
      } else {
        this.form.uploadedPhotos.push(image)
      }
    },

    /**
     * Remove selected photo
     *
     * @param {Number} photoIndex Index of photo to remove
     */
    removePhoto (photoIndex) {
      this.form.uploadedPhotos.splice(photoIndex, 1)
    },

    /**
     * check whether biz reviewed within 72 hours
     *
     * @returns {void}
     */
    isBizAlreadyReviewed () {
      axios.get(`/consumer/business/${this.form.business_slug}/biz-review-detail`)
        .then(({data}) => {
          if (data && data.lastReviewTimeDiff <= 72) {
            this.form.industry = ''
            this.slug = ''
            this.form.business_id = 0
            this.form.business_name = ''
            this.latestReview = data
            this.isErrorVisible = false
            flash(this.getDuplicateReviewErrorMessage, 'is-warning', true)
          } else {
            this.isErrorVisible = true
          }
        })
        .catch(() => {
          this.isErrorVisible = true
        })
        .finally(() => {
          this.form.reference_number = ''
          this.form.id_number = ''
          this.form.branch = ''
        })
    },
    getBasicBusinessDetail () {
      return new Promise((resolve) => {
        axios.get(`/consumer/business/${this.slug}/basic-detail`)
          .then(({data}) => {
            if (this.$route.query.blank == 'true' || this.$route.query.blank == true) {
              this.blankError()
            }
            this.businessPropertyDetail = data
            this.form.subscription = data.subscription
            this.form.business_id = data.id
            this.form.business_slug = this.slug
            this.form.business_name = data.name
            if (data.status !== 'ACTIVE' && data.subscription === '' && !data.accepted_invites_count) {
              this.showUnclaimedBizEmail = true
            } else {
              this.showUnclaimedBizEmail = false
            }
            window.prerenderReady = true
            this.$gtm.trackEvent({
              event: 'pageLoad',
              virtualPageUrl: this.$router.currentRoute.path,
              virtualPageTitle: this.metaTitle,
              brandName: data.name,
              industryName: ''
            })
            resolve()
          })
          .catch(() => {
            this.$router.push('/write-a-review')
          })
      })
    },
    publishReview () {
      this.form.errors.clear(null)
      this.is_loading = true
      this.form.business_slug = this.slug
      this.form.send('/consumer/reviews/write')
        .then((response) => {
          localStorage.setItem('new_review', JSON.stringify(response))
          this.is_loading = false

          this.recache() //Home page
          this.recacheReviewDetail(response.business_slug, response.permalink) //Review detail page
          this.recache(`/${response.business_slug}`) //Business detail page
          this.recache(`/industries/${response.industry_slug}`) //Industry details page

          this.$router.push('/thank-you')
        })
        .catch((err) => {
          this.is_loading = false
          if (err.error && err.already_written_review_for_invite) {
            this.$router.push(`/${err.business_slug}?already_written_review_for_invite=true`)
          } else if (err.error) {
            this.$router.push(`/${this.slug}?already_written_review_for_invite=true`)
          }
        })
    },
    hideDropdown () {
      this.show_dropdown = false
    },
    showDropdown () {
      this.show_dropdown = !this.show_dropdown
    },
    closeOrgLookup () {
      this.on_blur_close = true
      if (this.drop_down_opened) {
        this.hideBusinessAutoComplete()
      }
    },
    selectIndustry (industry) {
      this.form.industry = industry.industry_id
      this.selectedIndustry = industry.name
      this.show_dropdown = false
    },
    getIndustries () {
      axios.get('/search/industries/')
        .then(({data}) => {
          this.industries = data
        })
        .catch(() => {
          flash('Error retrieving the list of industries! Contact the System\'s Administrator.', 'is-danger', true)
        })
    },
    clearBusiness (inputVal) {
      this.form.business_slug = ''
      this.form.business_id = ''
      this.form.status = 'NEW'
      this.form.business_name = inputVal
    },
    clearBizSearch () {
      this.org_selected = false
      this.clearBusiness(this.form.business_name)
    },
    hideBusinessAutoComplete () {
      try {
        this.drop_down_opened = true
        this.on_blur_close = true
        const parent = this
        parent.business_available = false
        this.businesses.forEach((business) => {
          let inlist = false
          if (this.form.business_name.toLowerCase() === business.name.toLowerCase() && !inlist) {
            if (business.status === 'ACTIVE') {
              parent.business_available = false
              parent.org_selected = true
              parent.drop_down_opened = false
            } else if (!inlist) {
              inlist = true
              parent.org_selected = true
              parent.business_available = true
              parent.drop_down_opened = false
            }
          }
          if (this.form.business_name.toLowerCase() !== business.name.toLowerCase() && !inlist) {
            parent.business_available = true
            parent.drop_down_opened = false
            parent.org_selected = true
          }
        })
      } catch (e) {
      }
    },
    selectOrg (business) {
      if (typeof business !== 'undefined') {
        this.org_selected = true
        this.form.business_name = business.name.trim()
        this.form.business_slug = business.slug
        this.form.business_id = business.id
        this.form.status = business.status
        this.form.new_business_email = ''
        this.businesses = []

        if (typeof business.subscription !== 'undefined' && business.subscription !== null && typeof business.subscription.name !== 'undefined') {
          this.form.subscription = business.subscription.name
        }
        if (typeof business.id !== 'undefined' && business.id !== null) {
          this.isBizAlreadyReviewed()
        }

        if (business.status !== 'ACTIVE' && business.subscription === null && !business.accepted_invites_count) {
          this.showUnclaimedBizEmail = true
          this.form.subscription = ''
        } else {
          this.showUnclaimedBizEmail = false
        }
        this.drop_down_opened = false
      }
    },
    isReviewerAlreadyWrittenReviewForInvite () {
      let token = this.form.token
      axios.get(`/consumer/reviews/is-already-written-review-for-single-invite/${token}`)
        .then(({data}) => {
          this.is_new_user = data.is_new_user
          if (!data.is_valid) {
            this.$router.push(`/${data.business_slug}?already_written_review_for_invite=true`)
          }
        })
        .catch(() => {
          this.$router.push('/login')
        })
    },
    blankError () {
      this.isErrorVisible = false
      flash(this.getBlankErrorMessage, 'is-warning', true)
    },
    /**
     * Get template setting to valid add photo using token
     */
    getReviewTemplatesetting () {
      let token = this.form.token
      axios.get(`/consumer/reviews/review-template-setting/${token}`)
        .then((response) => {
          this.add_photo = response.data.add_photo
        }).catch(() => {
      })
    },
  },
  computed: {
    twentykCampImgName () {
      let suffix = this.deviceType
      if (this.deviceType === 'tablet') {
        suffix = 'desktop'
      }
      return `20k_campaign_${suffix}`
    },
    twentykCampImgPath () {
      return `/static/img/20k_campaign/banner/${this.twentykCampImgName}`
    },
    /**
     * Enable/disable feature of uploading photos
     *
     * @returns {boolean}
     */
    canUploadPhotos () {
      const allowedSubs = ['g1', 'g2', 'g3', 'g4', 'p1', 'p2', 'p3', 'p4']
      return (['UE9SVEFMX0lOVklURQ==', 'U01TX0lOVklURQ==', 'TEFORElOR19QQUdFX0VNQUlMX0lOVklURQ=='].includes(this.$route.query.source) && (this.add_photo === 'yes') && allowedSubs.indexOf(this.businessPropertyDetail.subscription.toLowerCase()) !== -1) //[Email invite, SMS invite]
    },
    /**
     * return error message in html string
     *
     * @returns {html}
     */
    getDuplicateReviewErrorMessage () {
      return `<ul>
            <li style="font-weight: 500;">It looks like you have recently reviewed this business. If you’re still unhappy, or need your issue resolved, you can do the following:</li>
            <li></li><li></li>
            <li style="font-weight: 500;margin-top:10px;list-style: disc;margin-left: 20px;">  Write a new message on your previous review explaining what you need from the business. <a class="link--v2 link--no-line" href="${this.form.business_slug}/reviews/${this.latestReview.permalink}" target="__blank">Write a new message.</a></li>
            <li ></li><li></li>
            <li style="font-weight: 500;list-style: disc;margin-left: 20px;">  Have a look at similar businesses in this industry who may be able to help you.<a class="ink--v2 link--no-line" href="/industries/${this.latestReview.industrySlug}" target="__blank"> View similar businesses.</a></li>
            <li></li><li></li>
            <li style="font-weight: 500;list-style: disc;margin-left: 20px;">  If none of these look good you can always <a class="ink--v2 link--no-line" href="/contact-us" target="__blank">contact us</a>, and let us know how we can help.</li>
        </ul>`
    },
    isMatchedToExistingBusiness () {
      const existingBusinessFromSlug = this.slug.length > 0 && this.businessPropertyDetail.id > 0
      const existingBusinessSelected = typeof this.form.business_id !== 'string' && this.form.business_id > 0
      return existingBusinessFromSlug || existingBusinessSelected
    },
    isBusinessFromSlug () {
      return this.slug.length > 0 && this.businessPropertyDetail.id > 0
    },
    shareYourExperienceMarkup () {
      return `Share your experience, review ${this.businessPropertyDetail.name}`
    },
    isBusinessAvailable () {
      return this.business_available
    },
    showOrgLookDropdown () {
      if (this.on_blur_close && !this.org_selected) {
        return ''
      }
      if ((this.org_selected || this.businesses.length > 0) && !this.on_blur_close) {
        return 'is-active'
      }
    },
    orgsFound () {
      return this.businesses.length > 0
    },
    disableDropDown () {
      return this.form.business_name === ''
    },
    disableRating () {
      const existingBusinessFromSlug = this.slug.length > 0 && this.businessPropertyDetail.id > 0
      const existingBusinessSelected = typeof this.form.business_id !== 'string' && this.form.business_id > 0
      if (existingBusinessFromSlug || existingBusinessSelected) {
        return false
      }
      return this.form.industry === '' || this.form.business_name === ''
    },
    disableReviewContent () {
      return this.form.rating === 0
    },
    disableReviewTitle () {
      return this.form.content === ''
    },
    /**
     * disable review email field
     *
     * @returns {boolean}
     */
    disableReviewEmail () {
      return this.form.review_title === ''
    },
    showAdditionalInformation () {
      const hasTitle = this.form.review_title.length > 0
      const hasContent = this.form.content.length > 0
      const isProOrEnterprise = this.form.subscription.toLowerCase() !== 'free' && this.form.subscription.length > 0
      return hasTitle && hasContent && isProOrEnterprise && this.isMatchedToExistingBusiness
    },
    showNewBusinessEmail () {
      const existingBusinessFromSlug = this.slug.length > 0 && this.businessPropertyDetail.id > 0
      const existingBusinessSelected = typeof this.form.business_id !== 'string' && this.form.business_id > 0
      return !(existingBusinessFromSlug || existingBusinessSelected) && this.form.business_name !== ''
    },
    disablePublishButton () {
      const hasBusiness = this.form.business_name.length > 0
      const hasTitle = this.form.review_title.length > 0
      const hasContent = this.form.content.length > 0
      const mustHaveAdditionalInfo = this.form.subscription.toLowerCase() !== 'free' && this.form.subscription.length > 0

      if (mustHaveAdditionalInfo) {
        let regex = /^\d{10}$/
        const hasValidMobile = regex.test(this.form.cell_number)
        return !(hasValidMobile && hasBusiness && hasTitle && hasContent)
      }

      return !(hasBusiness && hasTitle && hasContent)
    },
    isInvalidCellNumber () {
      if (this.form.cell_number.length === 0) {
        return false
      }
      let regex = /^\d{10}$/
      return !regex.test(this.form.cell_number)
    },
    metaTitle () {
      return 'Review Companies Online | Customer Service & Company Ratings | hellopeter.com'
    },
    /**
     * return blank error message in html string
     *
     * @returns {html}
     */
    getBlankErrorMessage () {
      return `<ul>
            <li style="font-weight: 500;">We encountered a problem when trying to publish your review. Please try again.</li>
        </ul>`
    },
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

#write-a-review {
  background-color: #F5F5F5;
  padding: 3rem;
}

.valentines-banner {
  display: block;
  margin: -20px auto 20px auto;
  width: 601px;
}

#twentykCampBanner, .write-review {
  margin: 0 auto;
  width: 601px;
}

#twentykCampBanner {
  @include mobile {
    width: 100%;
    text-align: center;
    background: #fff;
    padding-top: 11px;
  }

  img {
    vertical-align: bottom;
  }
}

.write-review {
  color: #58595B;
  padding: 2rem;
  background-color: #ffffff;
}

h1 {
  font-size: 1.3rem;
  margin-bottom: 1.8rem;
}

.label {
  color: #58595B;
  display: block;
  font-size: 0.85rem;
  font-weight: normal;
}

.field {
  margin-bottom: 30px;
}

.title {
  font-size: 1rem;
  color: #58595B;
  margin-bottom: 0.8rem;
}

.dropdown {
  width: 100%;

  .dropdown-trigger {
    width: 100%;

    .button-dropdown {
      text-align: left;
      min-width: 100%;
      background-color: #fff;
      border-radius: 20px;
      border: 1px solid #dbdbdb;
      padding: 10px 17.5px 9px 17.5px;
      color: map-get($colors, 'gray');

      &[disabled] {
        background-color: #f5f5f5;
        cursor: not-allowed;
      }

      .fa-angle-down {
        font-size: 1.4rem;

        &:before {
          border: 1px solid #95979b;
          border-right: 0;
          border-top: 0;
          content: " ";
          display: block;
          height: 0.5em;
          pointer-events: none;
          position: absolute;
          -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
          -webkit-transform-origin: center;
          transform-origin: center;
          width: 0.5em;
          margin-top: -0.375em;
          right: 1.125em;
          top: 50%;
          z-index: 4;
          right: 0.7em;
        }
      }
    }
  }

  &.is-active .button-dropdown {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .dropdown-menu {
    width: calc(100% - 2px);
    left: 1px;
  }
}

.is-size-6 {
  font-size: 0.85rem !important;
}

.disabled {
  color: lightgray !important;
}

.control:disabled, .control[readonly], .control:disabled::placeholder, .disabled .control::placeholder {
  background-color: transparent;
  color: lightgray;
}

@media screen and (max-width: 767px) {
  .valentines-banner {
    margin-bottom: 0px;
  }

  #write-a-review {
    padding: 0;
  }

  .write-review {
    padding: 1rem;
    width: 100%;
  }

  .bottom-margin {
    margin-bottom: 40px;
  }
}

*:focus {
  outline: none;
}

.clear {
  clear: both;
}

.required {
  color: red;
}

.isErrorVisible {
  display: none;
}

.invite-message {
  text-align: center;
  width: 75%;
  margin: 0px auto;
  margin-bottom: 20px;
}

.photo-row {
  line-height: 16px;
}

.photo-row-img {
  vertical-align: middle;
  margin-right: 10px;
  width: 21px;
}

.photo-row-thumbnail {
  width: 30px;
  height: 30px
}

.photo-row-remove {
  color: #9b9b9b;
  margin-top: 5px;
  margin-left: 10px;
}

.photo-row-error-img {
  width: 9px;
  margin: 4px 5px 0 0;
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

@include not-mobile {
  .hp-btn-primary {
    width: 234px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/reviews/WriteReview.vue